import { nativeCapabilities } from 'nest/capabilities';
import { GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP } from './global-keyboard-shortcut-listener.capability';
import { CHANGE_SEARCH_FILTER_CAP } from './change-search-filter.capability';
import { CHANGE_SEARCH_CAP } from './change-search.capability';
import { ADD_TO_BOOKMARKS_CAP } from './add-to-bookmarks.capability';
import { UPSERT_GLOBAL_STYLES_CAP } from './upsert-global-styles.capability';
import { DELETE_GLOBAL_STYLES_CAP } from './delete-global-styles.capability';
import { UPDATE_BELL_ICON_COUNT_CAP } from './update-bell-icon-count.capability';
import { UPDATE_CALL_ICON_STATUS_CAP } from './update-call-icon-status.capability';
import { UPDATE_THIRD_PARTY_CALL_STATUS_CAP } from './update-third-party-call-status.capability';
import { ALERT_MESSAGE_CAP } from './alert-message.capability';
import { TOGGLE_NOTIFICATION_SIDEBAR_CAP } from './toggle-notifications-sidebar.capability';
import { TOGGLE_CSAT_SURVEY_CAP } from './toggle-csat-survey.capability';
import { TOGGLE_WOOTRIC_SURVEY_CAP } from './toggle-wootric-survey.capability';
import { GLOBAL_HOME_WIDGET_TRACKING_CAP } from './global-home/global-home-widget-tracking.capability';
import { TRACK_WIDGET_INTERACTION_CAP } from './global-home/track-widget-interaction.capability';
import { SEARCH_INPUT_EVENT_CAP } from './search-input-event.capability';
import { REFETCH_CREDIT_BALANCE_CAP } from './refetch-credit-balance.capability';
export const capabilities = Object.assign({}, nativeCapabilities, {
  GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP,
  CHANGE_SEARCH_FILTER_CAP,
  CHANGE_SEARCH_CAP,
  ADD_TO_BOOKMARKS_CAP,
  UPSERT_GLOBAL_STYLES_CAP,
  DELETE_GLOBAL_STYLES_CAP,
  UPDATE_BELL_ICON_COUNT_CAP,
  UPDATE_CALL_ICON_STATUS_CAP,
  UPDATE_THIRD_PARTY_CALL_STATUS_CAP,
  ALERT_MESSAGE_CAP,
  TOGGLE_NOTIFICATION_SIDEBAR_CAP,
  TOGGLE_CSAT_SURVEY_CAP,
  TOGGLE_WOOTRIC_SURVEY_CAP,
  GLOBAL_HOME_WIDGET_TRACKING_CAP,
  TRACK_WIDGET_INTERACTION_CAP,
  SEARCH_INPUT_EVENT_CAP,
  REFETCH_CREDIT_BALANCE_CAP
});